import { IRootState } from '../../reducer';

export const selectLogoutModalTimer = (rootState: IRootState): number => {
  return rootState.modals.logoutModal.timer;
};

export const selectLogoutModalCause = (rootState: IRootState): string => {
  return rootState.modals.logoutModal.cause;
};
